import React from "react";
import useSettings from "../../../hooks/useSettings";
import Page from "../../../components/Page";
import {Container} from "@mui/material";
import HeaderBreadcrumbs from "../../../components/HeaderBreadcrumbs";
import { PATH_MANAGEMENT} from "../../../routes/paths";
import {useTranslation} from "react-i18next";
import DiscountCodeNewEditForm from "../../../sections/@dashboard/managements/discount-code/DiscountCodeNewEditForm";

const DiscountCodeCreate = () => {
    const { themeStretch } = useSettings();
    const {t} = useTranslation()

    return (
        <Page title={`${t('Create')} ${t('discountCode')}`}>
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <HeaderBreadcrumbs
                    heading={`${t('Create')} ${t('discountCode')}`}
                    links={[
                        {
                            name: t('Managements'),
                            href: PATH_MANAGEMENT.management.discountCode.root,
                        }, {
                            name: t('discountCode'),
                            href: PATH_MANAGEMENT.management.discountCode.root,
                        },
                        {name: t('Create')},
                    ]}
                />
                <DiscountCodeNewEditForm />
            </Container>
        </Page>
    );
}

export default DiscountCodeCreate;
